import React from 'react';
import { Tooltip, Menu } from 'antd';
import { SubMenuProps } from './types';
import './index.less';
import classNames from 'classnames';
import { useMenuSelect, useMenuActive } from './index';
import { selectedSvg, RedDot } from './partial';
interface Props {
  item: SubMenuProps;
  collapsed: boolean;
  isQuickStart?: boolean;
}

export default function FcSubMenu(props: Props) {
  const { item, collapsed, isQuickStart } = props;
  const [menuSelect, setMenuSelect] = useMenuSelect();
  const [menuActive, setMenuActive] = useMenuActive();
  const selected = menuSelect.includes(item.key) && menuSelect.length > 1;
  const hovering = menuActive.includes(item.key);
  const children = item.children || [item];
  const menu = (
    <Menu
      key={item.key}
      onClick={({ key, domEvent }) => {
        domEvent.stopPropagation();
        setMenuSelect([item.key, key]);
      }}
      selectedKeys={menuSelect}
    >
      {children
        .filter((i) => !!i)
        .map((item) => (
          <Menu.Item key={item.key}>{item.label}</Menu.Item>
        ))}
    </Menu>
  );

  const menuWithTitle = (
    <div style={{ textAlign: 'center' }}>
      <span className='collapse-menu-title'>{item.label}</span>
      {menu}
    </div>
  );
  return (
    <div
      className={classNames({
        'float-fc-menu-sub': true,
        'float-fc-menu-sub-hover': hovering,
        'float-fc-menu-sub-selected': selected,
      })}
    >
      <div className='fc-menu-sub-curve'></div>
      {hovering && (
        <>
          <div className='fc-menu-sub-topleft-corner'></div>
          <div className='fc-menu-sub-bottomleft-corner'></div>
          <div className='fc-menu-sub-left'></div>
        </>
      )}
      <div
        className='float-fc-menu-sub-title'
        onClick={(e) => setMenuSelect([item.key, children[0].key])}
        onMouseEnter={() => {
          setMenuActive([item.key]);
        }}
      >
        {selected && selectedSvg}
        {!hovering && selected && RedDot}

        <Tooltip
          title={collapsed && !isQuickStart && item.children ? menuWithTitle : menu}
          placement='right'
          overlayClassName={`float-fc-menu-sub-tooltip ${
            children.length === 1 ? 'float-fc-menu-sub-tooltip-single-child' : ''
          }`}
        >
          <div style={{ display: 'flex', flex: 1 }}>
            <span className='float-fc-menu-sub-title-icon'>
              {hovering && item.activeIcon ? item.activeIcon : item.icon}
            </span>
            {!collapsed && <span className='float-fc-menu-sub-title-label'>{item.label}</span>}
          </div>
        </Tooltip>
      </div>
    </div>
  );
}
